export const calculateMapCenter = (properties) => {
    const lats = properties.map(p => parseFloat(p.lat));
    const lngs = properties.map(p => parseFloat(p.lng));
    
    return {
      lat: (Math.max(...lats) + Math.min(...lats)) / 2,
      lng: (Math.max(...lngs) + Math.min(...lngs)) / 2
    };
  };
  
  export const calculateZoomLevel = (properties) => {
    const lats = properties.map(p => parseFloat(p.lat));
    const lngs = properties.map(p => parseFloat(p.lng));
    
    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);
    
    const latDiff = maxLat - minLat;
    const lngDiff = maxLng - minLng;
    const maxDiff = Math.max(latDiff, lngDiff);
    
    if (maxDiff <= 0.003) return 17;
    if (maxDiff <= 0.007) return 16;
    if (maxDiff <= 0.015) return 15;
    if (maxDiff <= 0.03) return 14;
    if (maxDiff <= 0.06) return 13;
    return 12;
  };